import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  BarChart3,
  FileText,
  Video,
  Scissors,
  Share2,
  CalendarDays,
} from 'lucide-react';

// Voci principali nella barra inferiore, nell'ordine del flusso di lavoro. La
// navigazione completa (Clienti, ecc.) è nel menu in alto a sinistra;
// l'account è in alto a destra.
const navigation = [
  { name: 'Da gestire', shortName: 'Da gestire', href: '/dashboard', icon: BarChart3 },
  { name: 'Copywriting', shortName: 'Copy', href: '/copywriter', icon: FileText },
  { name: 'Riprese', shortName: 'Riprese', href: '/videomaker', icon: Video },
  { name: 'Editing', shortName: 'Editing', href: '/editing', icon: Scissors },
  { name: 'Calendario', shortName: 'Calendario', href: '/calendario-editoriale', icon: CalendarDays },
  { name: 'Pubblicazione', shortName: 'Pubbl.', href: '/publisher', icon: Share2 },
];

const MobileBottomNav: React.FC = () => {
  const location = useLocation();

  return (
    <nav
      className="
        mobile-bottom-nav
        fixed bottom-0 left-0 right-0 z-50
        bg-white/95 dark:bg-gray-900/95
        backdrop-blur-lg
        border-t border-slate-200/80 dark:border-gray-700/80
        safe-area-bottom
        transition-colors duration-300
      "
      role="navigation"
      aria-label="Main navigation"
    >
      <div
        className="
          flex items-center justify-around
          px-1 sm:px-2
          py-1.5 sm:py-2
          max-w-lg mx-auto
        "
        role="tablist"
      >
        {navigation.map((item) => {
          // Attiva anche sulle sottopagine (es. /videomaker/contenuto/:id → Riprese)
          const isActive = location.pathname === item.href || location.pathname.startsWith(item.href + '/');
          return (
            <Link
              key={item.name}
              to={item.href}
              className={`
                nav-item relative flex flex-col items-center justify-center
                min-w-0 flex-1
                py-1.5 sm:py-2
                px-0.5 sm:px-1
                transition-all duration-200 overflow-hidden
                touch-manipulation
                active:scale-95
                ${isActive
                  ? 'text-slate-900 dark:text-slate-100 active'
                  : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300'
                }
              `}
              role="tab"
              aria-selected={isActive}
              aria-label={`Navigate to ${item.name}`}
              tabIndex={0}
            >
              <div
                className={`
                  nav-icon relative
                  p-2 sm:p-2.5
                  rounded-md
                  transition-all duration-200
                  ${isActive
                    ? 'bg-brand shadow-brand'
                    : 'bg-transparent'
                  }
                `}
              >
                <item.icon
                  className={`
                    h-5 w-5 sm:h-6 sm:w-6
                    transition-all duration-200
                    ${isActive ? 'text-slate-900' : 'text-slate-500 dark:text-slate-400'}
                  `}
                />
              </div>
              <span
                className={`
                  text-[9px] sm:text-[10px]
                  mt-0.5
                  font-medium truncate w-full text-center
                  ${isActive
                    ? 'text-slate-900 dark:text-slate-100'
                    : 'text-slate-500 dark:text-slate-400'
                  }
                `}
              >
                {item.shortName}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
